import { render, staticRenderFns } from "./CarouselConfig.vue?vue&type=template&id=66bc5e9a&scoped=true&"
import script from "./CarouselConfig.vue?vue&type=script&lang=js&"
export * from "./CarouselConfig.vue?vue&type=script&lang=js&"
import style0 from "./CarouselConfig.vue?vue&type=style&index=0&id=66bc5e9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bc5e9a",
  null
  
)

export default component.exports